import React, { useCallback } from 'react';
import styles from './ResetModal.module.scss';
import Modal from '@components/modal/Modal';
import Button from '@components/button/Button';

type Props = {
  title: string;
  description: React.ReactNode;
  resetTitle: string;
  cancelTitle?: string;
  reviewLessonButton?: string;
  open?: boolean;
  loading?: boolean;
  onClose?: () => void;
  onReset?: () => void;
  goToResetLesson?: () => void;
};

function ResetModal(props: Props) {
  const { title, description, resetTitle, cancelTitle, open, loading, reviewLessonButton, onClose, onReset, goToResetLesson } = props;

  const handleClose = useCallback(() => {
    if (reviewLessonButton && goToResetLesson) {
      goToResetLesson()
    } else {
      onClose?.();
    }
  }, [onClose, goToResetLesson, reviewLessonButton]);

  const handleReset = useCallback(() => {
    onReset?.();
  }, [onReset]);

  return (
    <Modal open={!!open} onClose={onClose} closeButton={false} className={styles.wrapper}>
      <div className={cancelTitle === 'No' ? styles.otherView : styles.mainView}>
        <div className={styles.title}>{title}</div>
        <div className={styles.detail}>{description}</div>
          <div className={styles.content}>
            <div className={styles.action}>
              {reviewLessonButton ? <>
                <Button size='small' className={styles.cancelButton} disabled={loading} onClick={handleClose} label={reviewLessonButton}/>
                <Button size='small' className={styles.cancelButton} disabled={loading} onClick={onClose} label={cancelTitle ? cancelTitle : 'Cancel'}/>
              </> : <>
                <Button size='small' className={styles.cancelButton} disabled={loading} onClick={onClose} label={cancelTitle ? cancelTitle : 'Cancel'}/>
                <Button size='small' className={styles.deleteButton} disabled={loading} isLoading={loading} onClick={handleReset} label={resetTitle}/>
              </>}
            </div>
          </div>
      </div>
    </Modal>
  );
}

export default ResetModal;
